import CaseNoData from '@/shared/publish/MyPublications/CaseNoData'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/MyPublications/CaseNoData')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CaseNoData />
}
